import { Blocks } from "../interfaces";

const blocks: Blocks[] = [
  // {
  //   id: 0,
  //   next: 1,
  //   color: "red",
  //   safe: false,
  //   top: 1,
  //   bottom: 2,
  //   left: 0,
  //   right: 0,
  // },
  // {
  //   id: 1,
  //   next: 2,
  //   color: "blue",
  //   safe: false,
  //   top: 1,
  //   bottom: 2,
  //   left: 10,
  //   right: 10,
  // },

  {
    id: 1,
    next: 2,
    color: "blue",
    safe: false,
    bottom: 0,
    left: 0,
    right: 10,
    top: 42.08,
  },
  {
    id: 2,
    next: 3,
    color: "blue",
    safe: false,
    bottom: 0,
    right: 0,
    top: 42.08,
    left: 5.26,
  },
  {
    id: 3,
    next: 4,
    color: "blue",
    safe: false,
    bottom: 0,
    right: 0,
    top: 42.08,
    left: 10.52,
  },
  {
    id: 4,
    next: 5,
    color: "blue",
    safe: true,
    bottom: 0,
    right: 0,
    top: 42.08,
    left: 15.78,
  },
  {
    id: 5,
    next: 6,
    color: "blue",
    safe: false,
    bottom: 0,
    right: 0,
    top: 42.08,
    left: 21.04,
  },
  {
    id: 6,
    next: 7,
    color: "blue",
    safe: false,
    bottom: 0,
    right: 0,
    top: 42.08,
    left: 26.3,
    simp3: true,
  },
  {
    id: 7,
    next: 8,
    color: "blue",
    safe: false,
    bottom: 0,
    right: 0,
    top: 42.08,
    left: 31.56,
  },
  {
    id: 8,
    next: 9,
    color: "blue",
    safe: false,
    bottom: 0,
    right: 0,
    top: 42.08,
    left: 36.82,
  },

  {
    id: 16,
    next: 17,
    color: "blue",
    safe: false,
    bottom: 0,
    right: 0,
    top: 0,
    left: 42.08,
  },
  {
    id: 15,
    next: 16,
    color: "blue",
    safe: false,
    bottom: 0,
    right: 0,
    top: 5.26,
    left: 42.08,
  },
  {
    id: 14,
    next: 15,
    color: "blue",
    safe: false,
    bottom: 0,
    right: 0,
    top: 10.52,
    left: 42.08,
  },
  {
    id: 13,
    next: 14,
    color: "blue",
    safe: true,
    bottom: 0,
    right: 0,
    top: 15.78,
    left: 42.08,
  },
  {
    id: 12,
    next: 13,
    color: "blue",
    safe: false,
    bottom: 0,
    right: 0,
    top: 21.04,
    left: 42.08,
  },
  {
    id: 11,
    next: 12,
    color: "blue",
    safe: false,
    bottom: 0,
    right: 0,
    top: 26.3,
    left: 42.08,
    simp1: true,
  },
  {
    id: 10,
    next: 11,
    color: "blue",
    safe: false,
    bottom: 0,
    right: 0,
    top: 31.56,
    left: 42.08,
  },
  {
    id: 9,
    next: 10,
    color: "blue",
    safe: false,
    bottom: 0,
    right: 0,
    top: 36.82,
    left: 42.08,
  },

  {
    id: 17,
    next: 18,
    color: "red",
    safe: false,
    bottom: 0,
    right: 0,
    top: 0,
    left: 47.34,
  },
  { id: 68, next: 69, color: "red", safe: false, top: 5.26, left: 47.34 },
  { id: 69, next: 70, color: "red", safe: false, top: 10.52, left: 47.34 },
  { id: 70, next: 71, color: "red", safe: false, top: 15.78, left: 47.34 },
  { id: 71, next: 72, color: "red", safe: true, top: 21.04, left: 47.34 },
  { id: 72, next: 73, color: "red", safe: false, top: 26.3, left: 47.34 },
  { id: 73, next: 74, color: "red", safe: false, top: 31.56, left: 47.34 },
  { id: 74, next: 75, color: "red", safe: false, top: 36.82, left: 47.34 },

  {
    id: 18,
    next: 19,
    color: "blue",
    safe: false,
    bottom: 0,
    right: 0,
    top: 0,
    left: 52.6,
  },
  {
    id: 19,
    next: 20,
    color: "blue",
    safe: false,
    bottom: 0,
    right: 0,
    top: 5.26,
    left: 52.6,
    simp4: true,
  },
  {
    id: 20,
    next: 21,
    color: "blue",
    safe: false,
    bottom: 0,
    right: 0,
    top: 10.52,
    left: 52.6,
  },
  {
    id: 21,
    next: 22,
    color: "blue",
    safe: true,
    bottom: 0,
    right: 0,
    top: 15.78,
    left: 52.6,
  },
  {
    id: 22,
    next: 23,
    color: "blue",
    safe: false,
    bottom: 0,
    right: 0,
    top: 21.04,
    left: 52.6,
  },
  {
    id: 23,
    next: 24,
    color: "blue",
    safe: false,
    bottom: 0,
    right: 0,
    top: 26.3,
    left: 52.6,
  },
  {
    id: 24,
    next: 25,
    color: "blue",
    safe: false,
    bottom: 0,
    right: 0,
    top: 31.56,
    left: 52.6,
  },
  {
    id: 25,
    next: 26,
    color: "blue",
    safe: false,
    bottom: 0,
    right: 0,
    top: 36.82,
    left: 52.6,
  },

  {
    id: 26,
    next: 27,
    color: "blue",
    safe: false,
    bottom: 0,
    top: 42.08,
    right: 36.82,
  },
  {
    id: 27,
    next: 28,
    color: "blue",
    safe: false,
    bottom: 0,
    top: 42.08,
    right: 31.56,
  },
  {
    id: 28,
    next: 29,
    color: "blue",
    safe: false,
    bottom: 0,
    top: 42.08,
    right: 26.3,
    simp3: true,
  },
  {
    id: 29,
    next: 30,
    color: "blue",
    safe: false,
    bottom: 0,
    top: 42.08,
    right: 21.04,
  },
  {
    id: 30,
    next: 31,
    color: "blue",
    safe: true,
    bottom: 0,
    top: 42.08,
    right: 15.78,
  },
  {
    id: 31,
    next: 32,
    color: "blue",
    safe: false,
    bottom: 0,
    top: 42.08,
    right: 10.52,
  },
  {
    id: 32,
    next: 33,
    color: "blue",
    safe: false,
    bottom: 0,
    top: 42.08,
    right: 5.26,
  },
  {
    id: 33,
    next: 34,
    color: "blue",
    safe: false,
    bottom: 0,
    top: 42.08,
    right: 0,
  },

  { id: 75, next: 76, color: "red", safe: false, top: 47.34, right: 36.82 },
  { id: 76, next: 77, color: "red", safe: false, top: 47.34, right: 31.56 },
  { id: 77, next: 78, color: "red", safe: false, top: 47.34, right: 26.3 },
  { id: 78, next: 79, color: "red", safe: true, top: 47.34, right: 21.04 },
  { id: 79, next: 80, color: "red", safe: false, top: 47.34, right: 15.78 },
  { id: 80, next: 81, color: "red", safe: false, top: 47.34, right: 10.52 },
  { id: 81, next: 82, color: "red", safe: false, top: 47.34, right: 5.26 },

  {
    id: 34,
    next: 35,
    color: "red",
    safe: false,
    bottom: 0,
    top: 47.34,
    right: 0,
  },

  {
    id: 35,
    next: 36,
    color: "blue",
    safe: false,
    bottom: 0,
    top: 52.6,
    right: 0,
  },
  {
    id: 36,
    next: 37,
    color: "blue",
    safe: false,
    bottom: 0,
    top: 52.6,
    right: 5.26,
    simp2: true,
  },
  {
    id: 37,
    next: 38,
    color: "blue",
    safe: false,
    bottom: 0,
    top: 52.6,
    right: 10.52,
  },
  {
    id: 38,
    next: 39,
    color: "blue",
    safe: true,
    bottom: 0,
    top: 52.6,
    right: 15.78,
  },
  {
    id: 39,
    next: 40,
    color: "blue",
    safe: false,
    bottom: 0,
    top: 52.6,
    right: 21.04,
  },
  {
    id: 40,
    next: 41,
    color: "blue",
    safe: false,
    bottom: 0,
    top: 52.6,
    right: 26.3,
  },
  {
    id: 41,
    next: 42,
    color: "blue",
    safe: false,
    bottom: 0,
    top: 52.6,
    right: 31.56,
    simp1: true,
  },
  {
    id: 42,
    next: 43,
    color: "blue",
    safe: false,
    bottom: 0,
    top: 52.6,
    right: 36.82,
  },

  { id: 43, next: 44, color: "blue", safe: false, bottom: 36.82, left: 52.6 },
  { id: 44, next: 45, color: "blue", safe: false, bottom: 31.56, left: 52.6 },
  {
    id: 45,
    next: 46,
    color: "blue",
    safe: false,
    bottom: 26.3,
    left: 52.6,
    simp3: true,
  },
  { id: 46, next: 47, color: "blue", safe: false, bottom: 21.04, left: 52.6 },
  { id: 47, next: 48, color: "blue", safe: true, bottom: 15.78, left: 52.6 },
  { id: 48, next: 49, color: "blue", safe: false, bottom: 10.52, left: 52.6 },
  {
    id: 49,
    next: 50,
    color: "blue",
    safe: false,
    bottom: 5.26,
    left: 52.6,
    simp3: true,
  },
  { id: 50, next: 51, color: "blue", safe: false, bottom: 0, left: 52.6 },

  { id: 51, next: 52, color: "red", safe: false, bottom: 0, left: 47.34 },
  { id: 82, next: 83, color: "red", safe: false, bottom: 5.26, left: 47.34 },
  { id: 83, next: 84, color: "red", safe: false, bottom: 10.52, left: 47.34 },
  { id: 84, next: 85, color: "red", safe: false, bottom: 15.78, left: 47.34 },
  { id: 85, next: 86, color: "red", safe: true, bottom: 21.04, left: 47.34 },
  { id: 86, next: 87, color: "red", safe: false, bottom: 26.3, left: 47.34 },
  { id: 87, next: 88, color: "red", safe: false, bottom: 31.56, left: 47.34 },
  { id: 88, next: 89, color: "red", safe: false, bottom: 36.82, left: 47.34 },

  { id: 52, next: 53, color: "blue", safe: false, bottom: 0, left: 42.08 },
  {
    id: 53,
    next: 54,
    color: "blue",
    safe: false,
    bottom: 5.26,
    left: 42.08,
    simp4: true,
  },
  { id: 54, next: 55, color: "blue", safe: false, bottom: 10.52, left: 42.08 },
  { id: 55, next: 56, color: "blue", safe: true, bottom: 15.78, left: 42.08 },
  { id: 56, next: 57, color: "blue", safe: false, bottom: 21.04, left: 42.08 },
  {
    id: 57,
    next: 58,
    color: "blue",
    safe: false,
    bottom: 26.3,
    left: 42.08,
    simp2: true,
  },
  { id: 58, next: 59, color: "blue", safe: false, bottom: 31.56, left: 42.08 },
  { id: 59, next: 60, color: "blue", safe: false, bottom: 36.82, left: 42.08 },

  { id: 60, next: 61, color: "blue", safe: false, top: 52.6, left: 36.82 },
  { id: 61, next: 62, color: "blue", safe: false, top: 52.6, left: 31.56 },
  { id: 62, next: 63, color: "blue", safe: false, top: 52.6, left: 26.3 },
  { id: 63, next: 64, color: "blue", safe: false, top: 52.6, left: 21.04 },
  { id: 64, next: 65, color: "blue", safe: true, top: 52.6, left: 15.78 },
  { id: 65, next: 66, color: "blue", safe: false, top: 52.6, left: 10.52 },
  {
    id: 66,
    next: 67,
    color: "blue",
    safe: false,
    top: 52.6,
    left: 5.26,
    simp3: true,
  },
  { id: 67, next: 0, color: "blue", safe: false, top: 52.6, left: 0 },

  { id: 89, next: 90, color: "red", safe: false, top: 47.34, left: 36.82 },
  { id: 90, next: 91, color: "red", safe: false, top: 47.34, left: 31.56 },
  { id: 91, next: 92, color: "red", safe: false, top: 47.34, left: 26.3 },
  { id: 92, next: 93, color: "red", safe: true, top: 47.34, left: 21.04 },
  { id: 93, next: 94, color: "red", safe: false, top: 47.34, left: 15.78 },
  { id: 94, next: 95, color: "red", safe: false, top: 47.34, left: 10.52 },
  { id: 95, next: 96, color: "red", safe: false, top: 47.34, left: 5.26 },
  { id: 0, next: 1, color: "red", safe: false, top: 47.34, left: 0 },

  // { id: 8, next: 9, color: "blue", safe: false, bottom: 0, left: 0, top: 42.08, left: 36.82 }
];

export default blocks;
